var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCloudLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.92 70.08L19.85 43.19C18.68 42.65 16.72 41.62 13.6 43.19C11.81 44.09 12.88 45.94 13.6 46.33L63.01 75.18C64.05 75.7 66.61 76.28 68.48 74.39C70.36 72.51 68.22 70.73 66.92 70.07V70.08Z",
    fill: "url(#paint0_linear_2548_296151)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.28 54.76C68.28 50.68 65.42 45.75 61.9 43.72C61.23 43.33 60.49 43.05 59.71 42.91C58.86 38.37 56.02 33.57 52.47 30.67C52.45 30.65 52.42 30.62 52.4 30.6C52.28 30.51 52.17 30.42 52.05 30.32L51.91 30.23L51.59 30L51.45 29.91L51.13 29.7L50.99 29.61C50.83 29.52 50.69 29.43 50.53 29.33C50.37 29.24 50.23 29.15 50.07 29.08L50.02 29.06C49.88 28.99 49.74 28.92 49.61 28.85L49.52 28.8C48.67 28.39 47.75 28.15 46.78 28.06C46.25 22.32 42.65 15.89 38.04 12.32C37.9 12.2 37.74 12.09 37.6 12C37.46 11.91 37.3 11.79 37.16 11.7L37.04 11.63C36.92 11.56 36.81 11.47 36.69 11.4C36.53 11.31 36.37 11.19 36.21 11.1C36.05 11.01 35.89 10.92 35.75 10.85L35.61 10.78C35.52 10.73 35.43 10.69 35.31 10.64L35.19 10.57L35.07 10.52C34.98 10.47 34.91 10.45 34.82 10.4L34.68 10.33C34.61 10.31 34.54 10.28 34.47 10.26L34.38 10.21L34.17 10.12L33.94 10.05L33.69 9.98L33.46 9.93001C33.37 9.91001 33.3 9.88 33.21 9.86L32.98 9.81001L32.73 9.74L32.52 9.69L32.29 9.67C32.22 9.67 32.15 9.65 32.08 9.65L31.85 9.63H31.18C31.11 9.63 31.02 9.63 30.95 9.65L30.77 9.67C30.7 9.67 30.61 9.69 30.54 9.69L30.36 9.71C30.29 9.73 30.2 9.73 30.13 9.76L29.97 9.81001C29.9 9.83001 29.81 9.86 29.74 9.88C29.67 9.9 29.65 9.90001 29.58 9.93001C29.49 9.95001 29.42 10 29.33 10.02C29.28 10.04 29.24 10.04 29.21 10.07C29.09 10.12 28.98 10.19 28.86 10.23L28.77 10.28L28.63 10.37L22.68 13.9L24.66 15.47C24.57 15.52 24.48 15.56 24.36 15.61H24.34L14.27 21.4L18.19 23.2L21.81 22.09C22.2 27.3 25.84 33.32 30.27 35.87L59.24 56.55L60.14 62.57L66.41 58.88H66.43L66.48 58.86C67.56 58.17 68.28 56.76 68.28 54.76Z",
    fill: "url(#paint1_linear_2548_296151)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.65 47.3801C54.98 46.9901 54.24 46.7101 53.46 46.5701C52.45 41.2201 48.73 35.5501 44.31 32.9901C42.97 32.2301 41.71 31.8101 40.55 31.7201C39.95 25.2401 35.46 17.8901 29.99 14.7301C24.11 11.3401 19.34 14.0801 19.34 20.8801C19.34 21.1101 19.34 21.3401 19.36 21.5701C15.07 19.5901 11.71 21.8201 11.71 26.9201C11.71 32.3401 15.51 38.9301 20.22 41.6301L55.67 62.1001C59.2 64.1301 62.05 62.4901 62.05 58.4101C62.05 54.3301 59.17 49.4001 55.64 47.3701L55.65 47.3801Z",
    fill: "url(#paint2_linear_2548_296151)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2548_296151",
    x1: 68.6,
    y1: 74.98,
    x2: 14.32,
    y2: 42.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#565656",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#171717",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2548_296151",
    x1: 20.49,
    y1: 9.93,
    x2: 63.49,
    y2: 60.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2548_296151",
    x1: 11.72,
    y1: 38.1301,
    x2: 62.06,
    y2: 38.1301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCloudLarge);
export default __webpack_public_path__ + "static/media/no_cloud_large.7f2754de18c92720df8c17f27dc0e646.svg";
export { ForwardRef as ReactComponent };